"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getPreferredProp;
var _lodash = require("lodash");
/**
 * Returns a prop by key prefering Redux-form 7 props, redux-form 5 props
 * or manual props in this order.
 * @param {object} props - all PropTypes
 * @param {string} key - the property to look for
 *
 */
function getPreferredProp(props, key) {
  var forcedPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var propsCopy = props;
  if (forcedPath) {
    propsCopy = (0, _lodash.get)(props, forcedPath, {});
  }
  return (0, _lodash.get)(propsCopy, "input.".concat(key), (0, _lodash.get)(propsCopy, "meta.".concat(key), (0, _lodash.get)(propsCopy, "field.".concat(key), (0, _lodash.get)(propsCopy, key, undefined))));
}